"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HorizontalStepper = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var system_1 = require("@mui/system");
var svgs_1 = require("../assets/svgs");
var ThemedConnector = (0, system_1.styled)(material_1.StepConnector)(function (_a) {
    var _b, _c, _d;
    var theme = _a.theme;
    return (_b = {},
        _b["&.".concat(material_1.stepConnectorClasses.active)] = (_c = {},
            _c["& .".concat(material_1.stepConnectorClasses.line)] = {
                borderColor: theme.palette.primary.main,
            },
            _c),
        _b["&.".concat(material_1.stepConnectorClasses.completed)] = (_d = {},
            _d["& .".concat(material_1.stepConnectorClasses.line)] = {
                borderColor: theme.palette.primary.main,
            },
            _d),
        _b["& .".concat(material_1.stepConnectorClasses.line)] = {
            borderColor: theme.palette.primary[300],
            padding: 0,
            minHeight: '8px',
        },
        _b);
});
var ThemedIconRoot = (0, system_1.styled)('div')(function (_a) {
    var theme = _a.theme, ownerState = _a.ownerState;
    return (__assign(__assign({ color: theme.palette.primary[400], display: 'flex', alignItems: 'center', justifyContent: 'center', width: 44, height: 44, borderStyle: 'solid', borderColor: theme.palette.primary[400], borderWidth: '2px', backgroundColor: 'transparent', borderRadius: '50%' }, (ownerState.active && {
        borderColor: theme.palette.primary.main,
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
    })), (ownerState.completed && {
        borderColor: theme.palette.primary.main,
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.secondary.main,
    })));
});
function QontoStepIcon(props, label, index) {
    var active = props.active, completed = props.completed, className = props.className;
    var mediumWindowSize = (0, material_1.useMediaQuery)(function (theme) {
        return theme.breakpoints.up('md');
    });
    return ((0, jsx_runtime_1.jsxs)(ThemedIconRoot, __assign({ ownerState: { active: active, completed: completed }, className: className }, { children: [completed ? ((0, jsx_runtime_1.jsx)(svgs_1.Check, { className: "QontoStepIcon-completedIcon", width: "12px", height: "12px" })) : ((0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ className: "QontoStepIcon-circle" }, { children: index + 1 }))), mediumWindowSize && ((0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: { position: 'absolute', top: "-".concat(22 + 8, "px") } }, { children: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ align: "center", color: active || completed ? 'primary.main' : 'primary.400' }, { children: label })) })))] })));
}
var ThemedStepLabel = (0, system_1.styled)(material_1.StepLabel)(function (_a) {
    var theme = _a.theme;
    return ({
        padding: '0.4rem 0rem',
        '.MuiStepLabel-label': {
            fontSize: '1.6rem !important',
        },
        '.Mui-completed': {
            color: theme.palette.primary.main,
        },
        '.Mui-active': {
            color: "".concat(theme.palette.primary.main, " !important"),
        },
    });
});
var HorizontalStepper = function (_a) {
    var steps = _a.steps, currentStep = _a.currentStep, onClick = _a.onClick;
    return ((0, jsx_runtime_1.jsx)(material_1.Stepper, __assign({ orientation: "horizontal", activeStep: currentStep, alternativeLabel: true, connector: (0, jsx_runtime_1.jsx)(ThemedConnector, {}) }, { children: steps.map(function (step, index) { return ((0, jsx_runtime_1.jsx)(material_1.Step, { children: (0, jsx_runtime_1.jsx)(ThemedStepLabel, { onClick: onClick(index), StepIconComponent: function (props) {
                    return QontoStepIcon(props, step.label, index);
                } }) }, step.label)); }) })));
};
exports.HorizontalStepper = HorizontalStepper;
